import { GlobalOutlined, WalletOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { history, useIntl, useModel } from '@umijs/max';
import {
  applyLocaleChange,
  LOCALE_OPTIONS,
  normalizeLocale,
} from '@/utils/locale';

export type SiderTheme = 'light' | 'dark';

export const LocaleToggle: React.FC = () => {
  const intl = useIntl();
  const currentLocale = normalizeLocale(intl.locale);

  return (
    <Dropdown
      trigger={['click']}
      overlayClassName="liquid-glass-dropdown"
      menu={{
        selectedKeys: [currentLocale],
        onClick: ({ key }) => applyLocaleChange(String(key)),
        items: LOCALE_OPTIONS.map((item) => ({
          key: item.value,
          label: item.label,
        })),
      }}
    >
      <Button
        type="text"
        className="top-nav-utility-button"
        aria-label="Switch language"
        title={LOCALE_OPTIONS.find((item) => item.value === currentLocale)?.label}
      >
        <GlobalOutlined />
      </Button>
    </Dropdown>
  );
};

export const Question: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const intl = useIntl();
  const locale = normalizeLocale(intl.locale);
  const purchaseLabel =
    {
      'zh-CN': '购买',
      'en-US': 'Buy',
      'ja-JP': '購入',
    }[locale] || '购买';
  
  // 如果配置为隐藏购买功能，则不渲染
  if (initialState?.siteConfig?.hidePurchaseFeature) {
    return null;
  }

  return (
    <Tooltip title={purchaseLabel}>
      <a
        className="top-nav-purchase-link"
        href="/membership/buy"
        onClick={(e) => {
          e.preventDefault();
          history.push('/membership/buy');
        }}
        aria-label={purchaseLabel}
      >
        <WalletOutlined className="top-nav-purchase-icon" aria-hidden="true" />
        <span className="top-nav-purchase-label">{purchaseLabel}</span>
      </a>
    </Tooltip>
  );
};
